export const sanitizeConfig = {
  img: ['src', 'alt', 'title'],
  p: [],
  strong: [],
  b: [],
  i: [],
  em: [],
  h1: ['id'],
  h2: ['id'],
  h3: ['id'],
  h4: ['id'],
  h5: ['id'],
  h6: ['id'],
  ul: [],
  ol: [],
  li: [],
  sub: [],
  sup: [],
  br: [],
  a: ['href'],
};
